





























import { Component, Vue, Prop, Emit} from 'vue-property-decorator';
import NotificationIndex from "@/components/notifications/Notifications.vue";
import ImportantNoticeIndex from "@/components/notifications/ImportantNotices.vue"
import InvoiceInfo from "@/consoleapi/api/invoice_info";

@Component({
  components: {
    NotificationIndex,
    ImportantNoticeIndex
  },
})

export default class Index extends Vue {
  @Prop() bearerToken!: string;
  @Prop() accountId!: string;
  @Prop() userId!: string;
  private billingType = "";

  @Prop() outstandingInvoiceId!: string;

  public getOutstandingInvoiceId(inputOutstandingInvoiceId: string) {
    this.inputOutstandingInvoiceIdEmit(inputOutstandingInvoiceId);
  }

  @Emit()
  public inputOutstandingInvoiceIdEmit(inputOutstandingInvoiceId: string) {
    // console.log('Emit2=>' + inputOutstandingInvoiceId);
  }

  private get inputOutstandingInvoiceId(): string {
    return this.outstandingInvoiceId;
  }

  private set inputOutstandingInvoiceId(outstandingInvoiceId: string) {
    this.inputOutstandingInvoiceIdEmit(outstandingInvoiceId);
  }

  mounted() {
    const invoiceInfo = new InvoiceInfo();
    invoiceInfo.setBearerToken(this.bearerToken);
    invoiceInfo.get(this.accountId).then(response => {
      this.billingType = response.data.billing_type;
    }).catch(error => {
      // console.log(error.response);
    })
  }
}
